import { render, staticRenderFns } from "./GlobalLoad.vue?vue&type=template&id=3f9dd66f&scoped=true"
import script from "./GlobalLoad.vue?vue&type=script&lang=js"
export * from "./GlobalLoad.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoad.vue?vue&type=style&index=0&id=3f9dd66f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9dd66f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f9dd66f')) {
      api.createRecord('3f9dd66f', component.options)
    } else {
      api.reload('3f9dd66f', component.options)
    }
    module.hot.accept("./GlobalLoad.vue?vue&type=template&id=3f9dd66f&scoped=true", function () {
      api.rerender('3f9dd66f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalLoad/GlobalLoad.vue"
export default component.exports